export default __webpack_public_path__ + "static/media/IMG_9407.0242fadb.JPG";